import { DataView } from "primereact/dataview";
import { ProgressSpinner } from "primereact/progressspinner";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDateWithTime, localeDateEndDate, localeDateStartDate } from "../../constants/DateUtil/DateUtil";
import { getStoreLocalData, getUserData } from "../../utils/localStorage";
import { getDashboardPaymentOrderRefund } from "../../services/PaymentCollection/DashboardPaymentCollection";
import DashboardPaymentRefundItem from "./DashboardPaymentRefundItem";
import SchedularModal from "../SchedularModal";

const DashboardPaymentRefund = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const { orderFilterData } = location.state || {}; // Fallback to prevent undefined errors

  const { brandProfileData } = getUserData();
  let brandId = brandProfileData.id;

  const { storeLocalData } = getStoreLocalData();

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate()); // subtract 7 days to current date

  const [paymentCollectionData, setPaymentCollectionData] = useState([]);
  const [
    dashboardPaymentCollectionSchedularModalVisible,
    setDashboardPaymentCollectionSchedularModalVisible,
  ] = useState(false);
  const [schedularDate, setSchedularDate] = useState({});
  const [categorizedPaymentData, setCategorizedPaymentData] = useState({});
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");

  const [loading, setLoading] = useState(false);
  const [
    dashboardPaymentRefundItemModalVisible,
    setDashboardPaymentRefundItemModalVisible,
  ] = useState(false);
  const [selectedPaymentRefundItemValue, setSelectedPaymentRefundItemValue] =
    useState("");

  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setSchedularDate(newSchedular);
  };

  const handleCalendarModal = () => {
    setDashboardPaymentCollectionSchedularModalVisible(true);
  };

  const getPaymentCollectionData = async (data) => {
    try {
      setLoading(true);
      const response = await getDashboardPaymentOrderRefund(data);
      if (!response.data.error) {
        const paymentModes = {};
        response.data.forEach((item) => {
          const mode = item.paymentMode;
          if (!paymentModes[mode]) {
            paymentModes[mode] = [];
          }
          paymentModes[mode].push(item);
        });
        setCategorizedPaymentData(paymentModes);
        setPaymentCollectionData(response.data);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching payment collection data", error);
    }
  };

  useEffect(() => {
    const data = {
      startDate:
        localeDateStartDate(new Date(schedularDate.startDate)) || localeDateStartDate(new Date(new Date(orderFilterData?.startDate))),
      endDate: localeDateEndDate(new Date(schedularDate.endDate)) || localeDateEndDate(new Date(new Date(orderFilterData?.endDate))),
      storeIds: orderFilterData.storeIds,
      statusIn: orderFilterData.statusIn,
      orderSourceIn: orderFilterData.orderSourceIn,
      paymentSourceIn: orderFilterData.paymentSourceIn,
    };
    getPaymentCollectionData(data);
  }, [orderFilterData, schedularDate]);

  useEffect(() => {
    const data = {
      startDate: localeDateStartDate(new Date(orderFilterData.startDate)),
      endDate: localeDateEndDate(new Date(orderFilterData.endDate)),
      storeIds: orderFilterData.storeIds,
      statusIn: orderFilterData.statusIn,
      paymentSourceIn: orderFilterData.paymentSourceIn,
      orderSourceIn: orderFilterData.orderSourceIn,
    };
    getPaymentCollectionData(data);
  }, []);


  const itemTemplate = (order, index) => {
    const OrderStatusColors = {
      ROLE_STORE: "#F2BB66",
      ROLE_RIDER: "#808000",
      DEFAULT: "#F2BB66",
    };

    const orderStatusColor = OrderStatusColors.DEFAULT;
    const formattedDate = formatDateWithTime(order.createdDate);
    return (
      <div
        className="cursor-pointer px-2 py-1 flex gap-6 my-2"
        style={{ backgroundColor: orderStatusColor, borderRadius: 5  }}
        onClick={() => {
          setDashboardPaymentRefundItemModalVisible(true);
          setSelectedPaymentRefundItemValue(order); // Set the selected item when opening the modal
        }}
      >
        <p className="text-lg text-white font-bold capitalize">
          {index + 1} | {formattedDate} 
        </p>
        <p className="text-lg text-white font-bold capitalize">
          {order.paymentMode} {storeLocalData?.currencySymbol} {order.amount}
        </p>
      </div>
    );
  };

  const calculateTotalDataCollection = () => {
    return paymentCollectionData.reduce(
      (total, item) => total + item?.amount,
      0
    );
  };

  const listTemplate = (items) => {
    if (!items || items.length === 0) return null;

    let list = items.map((product, index) => {
      return itemTemplate(product, index);
    });

    return <div>{list}</div>;
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <i
                className="pi pi-angle-left cursor-pointer"
                onClick={() => navigate("/full-dashboard")}
                style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
              ></i>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">Refund</p>
            </div>
          </div>
          <div
            onClick={() => handleCalendarModal()}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 30 }}
            />
          </div>
        </div>
      </div>

      <div
        className="flex gap-3 mb-3 mx-4 my-2 "
        style={{
          overflowX: "auto",
          whiteSpace: "nowrap",
        }}
      >
        {paymentCollectionData.length > 0 && (
          <div
            style={{ backgroundColor: "#2B70D7", borderRadius: 50 }}
            className="px-3 py-2 cursor-pointer"
            onClick={() => setSelectedPaymentMode("")}
          >
            <p className="text-white text-xl font-bold uppercase">
              TOTAL CASH REFUND ({storeLocalData?.currencySymbol} {calculateTotalDataCollection()})
            </p>
          </div>
        )}
      </div>
      <div className="mx-4 my-2">
        {loading ? (
          <div className="text-center">
            <ProgressSpinner />
          </div>
        ) : paymentCollectionData.length === 0 ? (
          <div className="text-center">
            <p className="text-xl font-medium">No Orders To Display</p>
          </div>
        ) : (
          <DataView
            value={
              selectedPaymentMode
                ? categorizedPaymentData[selectedPaymentMode]
                : paymentCollectionData
            }
            listTemplate={listTemplate}
            paginator
            rows={10}
          />
        )}
      </div>
        <SchedularModal
        setSchedularModalVisible={setDashboardPaymentCollectionSchedularModalVisible}
        schedularModalVisible={dashboardPaymentCollectionSchedularModalVisible}
        sendDataToOrdersPage={receiveDataFromSchedularModal}
        typeOfOrder={''}
      />
        <DashboardPaymentRefundItem
          setDashboardPaymentRefundItemModalVisible={
            setDashboardPaymentRefundItemModalVisible
          }
          dashboardPaymentRefundItemModalVisible={
            dashboardPaymentRefundItemModalVisible
          }
          selectedPaymentRefundItemValue={selectedPaymentRefundItemValue}
        />
    </div>
  );
};

export default DashboardPaymentRefund;
